import React from 'react';
import PropTypes from 'prop-types';


class ButtonUnstyled extends React.PureComponent {
  render() {
    let classes = this.props.classes;
    classes.push('button');
    classes.push('button-unstyled');
    classes.push('js-register-advance');
    if (this.props.active) classes.push('active');
    return (<button className={classes.join(' ')} type="button" onClick={this.props.onClick}>{this.props.label}</button>);
  }
}

ButtonUnstyled.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  active: PropTypes.bool,
  classes: PropTypes.array,
};

ButtonUnstyled.defaultProps = {
  onClick: () => console.log('fire button'),
  active: false,
  classes: [],
};

export default ButtonUnstyled;




// WEBPACK FOOTER //
// ./src/Components/Button/unstyled.jsx